export class SupportEmail {
    constructor(
      public problem: string = "",
      public description: string = "",

    ) {}
  }